export const FilterIcon = () => {
  return (
    <svg
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33301 7.33317H8.66634M1.33301 0.666504H14.6663H1.33301ZM3.99967 3.99984H11.9997H3.99967Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
